import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Flame, ShieldCheck } from "lucide-react";
import { formatErr } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@stylefire.in");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") { toast.error("Not an admin account"); return; }
      toast.success("Welcome, Admin");
      nav("/admin");
    } catch (e) { toast.error(formatErr(e?.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen grid place-items-center bg-[#0F172A] text-white p-6">
      <div className="w-full max-w-md bg-white text-slate-900 rounded-3xl p-8 shadow-2xl">
        <div className="flex items-center gap-2 mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#004BCA] text-white"><Flame size={20}/></span>
          <div><div className="font-display font-bold text-xl">Stylefire Admin</div><div className="text-xs text-slate-500 flex items-center gap-1"><ShieldCheck size={12}/> Secure access</div></div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <Input label="Admin Email" type="email" value={email} onChange={setEmail} testid="admin-email"/>
          <Input label="Password" type="password" value={password} onChange={setPassword} testid="admin-password"/>
          <button data-testid="admin-login-submit" disabled={loading} className="btn-primary-sf w-full py-3 rounded-full font-semibold disabled:opacity-60">{loading?"Signing in…":"Sign in"}</button>
        </form>
      </div>
    </main>
  );
}
function Input({ label, type="text", value, onChange, testid }) {
  return <label className="block"><span className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">{label}</span>
    <input data-testid={testid} type={type} value={value} onChange={e=>onChange(e.target.value)} required className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm focus:border-[#004BCA] focus:bg-white"/></label>;
}
